import AuctionTile from "./AuctionTile";

export default AuctionTile;
